import {
  searchAddressesFromLotParcel,
  searchLotParcelFromAddress
} from "../../../services/govMapApi";

export const searchHaklaiAddressesFromLotParcel = (token, lot, parcel) => (
  searchAddressesFromLotParcel(token, lot, parcel)
);

export const searchHaklaiLotParcelFromAddress = (token, address) => (
  searchLotParcelFromAddress(token, address)
);
